import { Button, Card, Checkbox, Col, message, Row } from "antd";
import { useEffect, useState } from "react";
import { CoreResource, t } from "shared/plugins/localization";
import {
  getOrderCodPaymentSettingAPI,
  updateOrderCodPaymentSettingAPI,
} from "states/payment-setting/payment-setting.api";
import { OrderCodPaymentSettingModel } from "states/payment-setting/payment-setting.models";

export interface IPaymentCodSettingProps {}

export function PaymentCodSetting(props: IPaymentCodSettingProps) {
  const [loading, setLoading] = useState(false);
  const [model, setModel] = useState<OrderCodPaymentSettingModel>({
    isActive: false,
  });

  const onSubmit = async () => {
    setLoading(true);
    try {
      await updateOrderCodPaymentSettingAPI(model);
      message.success(t(CoreResource, "UpdateDataSuccessfully"));
    } catch (error) {
      message.error(
        error?.response?.data?.error?.message ??
          t(CoreResource, "DefaultErrorMessage")
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    getOrderCodPaymentSettingAPI().then((res) => {
      setModel(res.data);
    });
  }, []);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Button
          loading={loading}
          disabled={loading}
          onClick={onSubmit}
          type="primary"
        >
          Lưu
        </Button>
      </Col>
      <Col span={12} xxl={8}>
        <Card title="Thanh toán COD">
          <Checkbox
            checked={model.isActive}
            onChange={(e) => {
              setModel({ ...model, isActive: e.target.checked });
            }}
          >
            Kích hoạt
          </Checkbox>
        </Card>
      </Col>
    </Row>
  );
}
